var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"sanction-field"},[_c('span',{staticClass:"sanction-field__label"},[_vm._v(_vm._s(_vm.props.label)+":")]),_c('span',{staticClass:"sanction-field__value"},[_vm._v(_vm._s(_vm.props.value || _vm.getNoDataValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }